var _require = require('./publish.escape'),
  escapeHTML = _require.escapeHTML;
var _require2 = require('./publish.flow'),
  shareRows = _require2.shareRows;
function pagesCoverAll(pages, pageCount) {
  var count = Number(pageCount) || 0;
  if (count < 1 || pages.length !== count) {
    return false;
  }
  for (var page = 1; page <= count; page += 1) {
    if (!pages.includes(page)) {
      return false;
    }
  }
  return true;
}
function requirementLines(actions, userIndex, pageCount) {
  var mine = (actions || []).filter(function (action) {
    return Number(action.user) === userIndex && (action.type === 'signature' || action.type === 'initial');
  });
  var pagesByType = {
    initial: new Set(),
    signature: new Set()
  };
  var seenGroups = {
    initial: new Set(),
    signature: new Set()
  };
  mine.forEach(function (action) {
    var type = action.type;
    var page = Number(action.page);
    if (!Number.isInteger(page) || page < 1) {
      return;
    }
    var group = String(action.group || '').trim();
    if (group) {
      if (seenGroups[type].has(group)) {
        return;
      }
      seenGroups[type].add(group);
      mine.forEach(function (item) {
        if (item.type !== type || String(item.group || '').trim() !== group) {
          return;
        }
        var groupedPage = Number(item.page);
        if (Number.isInteger(groupedPage) && groupedPage > 0) {
          pagesByType[type].add(groupedPage);
        }
      });
      return;
    }
    pagesByType[type].add(page);
  });
  var lines = [];
  ['initial', 'signature'].forEach(function (type) {
    var pages = Array.from(pagesByType[type]).sort(function (left, right) {
      return left - right;
    });
    if (!pages.length) {
      return;
    }
    var kind = type === 'initial' ? 'Initials' : 'Signature';
    var where = pagesCoverAll(pages, pageCount) ? 'all pages' : "pages ".concat(pages.join(', '));
    lines.push("".concat(kind, " required: ").concat(where));
  });
  return lines;
}
function peopleHTML(state) {
  var rows = shareRows(state).map(function (row) {
    var icon = row.signed ? 'fa-check' : 'fa-xmark';
    var label = row.signed ? 'signed' : 'not signed';
    var requirements = (row.requirements || []).map(function (line) {
      return "<li>".concat(escapeHTML(line), "</li>");
    }).join('');
    var list = requirements ? "<ul class=\"signer-requirements\">".concat(requirements, "</ul>") : '';
    return "\n        <li class=\"signer".concat(row.signed ? ' signed' : ' unsigned', "\">\n          <div class=\"signer-heading\">\n            <i class=\"fa-solid ").concat(icon, " signer-mark\" aria-hidden=\"true\"></i>\n            <span class=\"signer-name\">").concat(escapeHTML(row.name)).concat(row.creator ? ' (creator)' : '', " \u2014 ").concat(label, "</span>\n          </div>\n          ").concat(list, "\n        </li>\n      ");
  }).join('');
  return "<ul class=\"signer-list\">".concat(rows, "</ul>");
}
function finalizeActions() {
  return "\n    <p class=\"share-instruction\">This document is ready to be finalized. Click below and we'll prepare the document for users to sign.</p>\n    <div class=\"status-actions\">\n      <button type=\"button\" class=\"saito-button-primary\" data-publish-action=\"finalize\">Finalize Documents</button>\n    </div>\n  ";
}
function signedActions(premium) {
  var instruction = premium ? 'All required signatures have been completed. Export this document, or upload it to our server and generate a link, to share the completed copy.' : 'All required signatures have been completed. Export this document to share the completed copy.';
  var upload = premium ? '<button type="button" class="status-choice" data-publish-action="upload-share">UPLOAD AND SHARE</button>' : '';
  var layout = upload ? ' premium' : ' single';
  return "\n    <p class=\"share-instruction\">".concat(escapeHTML(instruction), "</p>\n    <div class=\"status-choices").concat(layout, "\">\n      <button type=\"button\" class=\"status-choice\" data-publish-action=\"share\">EXPORT DOCUMENT</button>\n      ").concat(upload, "\n    </div>\n  ");
}
function distributeActions(premium) {
  var upload = premium ? '<button type="button" class="status-choice" data-publish-action="upload-share">UPLOAD AND SHARE</button>' : '';
  var layout = upload ? ' premium' : ' single';
  return "\n    <p class=\"share-instruction\">Click below to export this document, distribute it to the signers.</p>\n    <div class=\"status-choices".concat(layout, "\">\n      <button type=\"button\" class=\"status-choice\" data-publish-action=\"share\">EXPORT DOCUMENT</button>\n      ").concat(upload, "\n    </div>\n  ");
}
function readyActions() {
  return "\n    <p class=\"share-instruction\">This document is now ready to be signed. Please select an option below.</p>\n    <div class=\"status-choices\">\n      <button type=\"button\" class=\"status-choice\" data-publish-action=\"sign-now\">I need to sign this document.</button>\n      <button type=\"button\" class=\"status-choice\" data-publish-action=\"skip-sign\">I don't need to sign this document.</button>\n    </div>\n  ";
}
function shareSlide(state) {
  var premium = state.plan === 'premium';
  var status = state.actionStatus;
  var fullySigned = Boolean(status) && status.required > 0 && status.remaining === 0;
  var actions = finalizeActions();
  if (state.finalized) {
    if (fullySigned) {
      actions = signedActions(premium);
    } else if (state.distributeOnly) {
      actions = distributeActions(premium);
    } else {
      actions = readyActions();
    }
  }
  return {
    title: 'Document Status',
    body: "\n      <div class=\"share-step\">\n        ".concat(peopleHTML(state), "\n        ").concat(actions, "\n      </div>\n    ")
  };
}
module.exports = shareSlide;
module.exports.requirementLines = requirementLines;